import { render, staticRenderFns } from "./TdcV3.vue?vue&type=template&id=b41845b2&scoped=true&"
import script from "./TdcV3.vue?vue&type=script&lang=js&"
export * from "./TdcV3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41845b2",
  null
  
)

export default component.exports